<template>
    <div class="home-swipe">
        <van-swipe :autoplay="3000" indicator-color="white" >
            <!-- :show-indicators="false" -->
            <van-swipe-item><img src="../assets/home1.jpg" alt=""></van-swipe-item>
            <van-swipe-item><img src="../assets/home2.jpg" alt=""></van-swipe-item>
            <van-swipe-item><img src="../assets/home3.jpg" alt=""></van-swipe-item>
            <van-swipe-item><img src="../assets/home4.jpg" alt=""></van-swipe-item>
            <van-swipe-item><img src="../assets/home5.jpg" alt=""></van-swipe-item>
            <van-swipe-item><img src="../assets/home6.jpg" alt=""></van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
export default {};
</script>

<style lang="less">
.home-swipe {
    background: red;
    .van-swipe {
        .van-swipe-item{
            img{
                width: 100%;
                display: block;
            }
        }
    }
}
</style>
